<button matIconButton [matMenuTriggerFor]="menu" aria-label="Toggle menu">
  <mat-icon fontSet="material-icons-outlined">menu</mat-icon>
</button>
<mat-menu #menu="matMenu" xPosition="before" class="mainMenu">
  @if (canShowMenu.dashboard) {
    @if (!isNewApplicant) {
      <a routerLink="/dashboard" mat-menu-item routerLinkActive="active">
        <mat-icon fontSet="material-icons-outlined">dashboard_2</mat-icon>
        Dashboard
      </a>
    } @else {
      <a routerLink="/dashboard/new-application" mat-menu-item routerLinkActive="active">
        <mat-icon fontSet="material-icons-outlined">dashboard_2</mat-icon>
        Dashboard
      </a>
    }
  }
  @if (!isNewApplicant) {
    <!-- school user -->
    @if (!isAccreditor && !isFederation) {
      @if(programRequestKey) {
        <a [routerLink]="['/accreditation/workspace', RoutesEnum.Institution, programRequestKey]" mat-menu-item routerLinkActive="active">
          <mat-icon>grading</mat-icon>
          Accreditation Events
        </a>
      }

    <!-- single or multiple profile -->
    @if (canShowMenu.hasMenuInstitutionalDirectory) {
      <app-accreditation-profile
        [profiles]="accreditationProfiles"
        [annualUpdate]="false"
      >
      </app-accreditation-profile>
    }
    @if (canShowMenu.hasMenuProgramDirectory) {
      <app-program-profile
        [profiles]="programProfiles"
        [annualUpdate]="false"
      ></app-program-profile>
    }

    <!-- single or multiple annual update -->
    @if (canShowMenu.hasMenuInstitutionalDirectory) {
      <app-accreditation-profile
        [profiles]="accreditationProfiles"
        [annualUpdate]="true"
      >
      </app-accreditation-profile>
    }
    @if (canShowMenu.hasMenuProgramDirectory) {
      <app-program-profile
        [profiles]="programProfiles"
        [annualUpdate]="true"
      ></app-program-profile>
    }
  }

    @if (canShowMenu.institutions) {
      <a routerLink="/accreditation/institutions" mat-menu-item routerLinkActive="active">
        <mat-icon fontSet="material-icons-outlined">grading</mat-icon>
        Institutions
      </a>
    }
    @if (canShowMenu.institutionsDirectory) {
      <a routerLink="/directory/institutions" mat-menu-item routerLinkActive="active">
        <mat-icon fontSet="material-icons-outlined">view_list</mat-icon>
        Directory
      </a>
    }
    @if (canShowMenu.programsDirectory) {
      <a routerLink="/directory/programs" mat-menu-item routerLinkActive="active">
        <mat-icon fontSet="material-icons-outlined">view_list</mat-icon>
        Directory
      </a>
    }
    @if(canShowMenu.federationDirectory){
      <a routerLink="/directory/federation" mat-menu-item routerLinkActive="active">
        <mat-icon fontSet="material-icons-outlined">groups</mat-icon>
        Members
      </a>
    }
    @if (canShowMenu.showApplicationTab) {
      <a routerLink="/applications" mat-menu-item routerLinkActive="active">
        <mat-icon fontSet="material-icons-outlined">assignment</mat-icon>
        Applications
      </a>
    }
    @if (canShowMenu.evaluators) {
      <a routerLink="/accreditation/reviewers" mat-menu-item routerLinkActive="active">
        <mat-icon fontSet="material-icons-outlined">content_paste_search</mat-icon>
        Reviewers
      </a>
    }
    @if (canShowMenu.annualReportsTemplateEdit) {
      <a routerLink="/directory/annual-report-template-editor" mat-menu-item routerLinkActive="active">
        <mat-icon fontSet="material-icons-outlined">build</mat-icon>
        Annual Reports Template
      </a>
    }
  }
</mat-menu>
